<script>
import eventBus from "../mixins/eventBus"

export default {

    data() {
        return {
            isValid: false,
        }
    },

    created() {
        let self = this;

        eventBus.$on('password-validated', () => {
            self.isValid = true;
        });

        eventBus.$on('password-invalidated', () => {
            self.isValid = false;
        })
    },

}
</script>
